// src/pages/CoachingDashboard.jsx
import React, { useEffect, useState } from 'react';
import MaterialModal from './MaterialModal';
import { FolderIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../../context/AuthContext';

const CoachingDashboard = () => {
    const { user } = useAuth();
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [materials, setMaterials] = useState([]);

        useEffect(() => {
            // Importación dinámica basada en el username
            import(`../../data/users/${user.username}/coachingData`)
                .then(module => {
                    setMaterials(module.materials);
                })
                .catch(err => console.error("No se encontraron datos para este usuario", err));
        }, [user.username]);
        
    return (
    <div className="bg-gray-900 min-h-screen pt-16">
        <div className="min-h-screen bg-black text-white p-8">
            <div className="max-w-6xl mx-auto">
                <header className="mb-12">
                    <h1 className="text-5xl font-bold mb-4">Coaching Material</h1>
                    <p className="text-gray-400 text-lg">Your personalized growth portal. Select a module to begin.</p>
                </header>

                {/* AQUÍ ESTÁ EL MAPEO DE TARJETAS */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {materials.map((item) => (
                        <div 
                            key={item.id} 
                            onClick={() => setSelectedMaterial(item)}
                            className="bg-gray-900/50 p-6 rounded-xl border border-gray-800 hover:border-indigo-500 transition-all cursor-pointer group"
                        >
                            <div className="mb-4">
                                <FolderIcon className="w-8 h-8 text-indigo-500" />
                            </div>
                            <h3 className="text-xl font-semibold mb-2 group-hover:text-indigo-400 transition-colors">
                                {item.title}
                            </h3>
                            <p className="text-gray-500 text-sm mb-4">
                                {item.description}
                            </p>
                            <div className="flex items-center gap-2">
                                <span className="text-xs bg-gray-800 px-2 py-1 rounded text-gray-300">
                                    {item.assets ? item.assets.length : 0} items
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal que se abre al hacer click en una tarjeta */}
            {selectedMaterial && (
                <MaterialModal 
                    material={selectedMaterial} 
                    user={user} 
                    onClose={() => setSelectedMaterial(null)} 
                />
            )}
        </div></div>
    );
};

export default CoachingDashboard;